
<div class="exam-wrapper video-wrapper rewatch rewatch-wrapper nopadding">
  <ng-container  [ngSwitch]="data.videoLink">
      <iframe *ngSwitchCase="'taketest'" width="100%" height="100%" src="https://www.youtube.com/embed/zzZX60xvgww?playlist=zzZX60xvgww&loop=1"
      title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen></iframe>
      <iframe *ngSwitchCase="'preparetest'" width="100%" height="100%" src="https://www.youtube.com/embed/j8ZOZno4Phk?playlist=j8ZOZno4Phk&loop=1"
      title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen></iframe>
  </ng-container>
  
</div>